import React from "react";
import "./LinksSection.css"; // Import external CSS for better styling

const LinksSection = () => {
  return (
    <div className="links-section-container">
      <div className="links-section-content">
        {/* Products */}
        <div>
          <h4 className="links-section-heading">PRODUCTS</h4>
          <ul className="links-list">
            <li>
              <a href="/products#mutual-funds" className="link-item">
                Mutual Funds
              </a>
            </li>
            <li>
              <a href="/products#capital-market" className="link-item">
                Capital Market
              </a>
            </li>
            <li>
              <a href="/products#pms" className="link-item">
                PMS
              </a>
            </li>
            <li>
              <a href="/products#fixed-income" className="link-item">
                Fixed Income
              </a>
            </li>
            <li>
              <a href="/products#insurance" className="link-item">
                Insurance
              </a>
            </li>
            <li>
              <a href="/products#real-estate" className="link-item">
                Real Estate
              </a>
            </li>         
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="links-section-heading">SERVICES</h4>
          <ul className="links-list">
            <li>
              <a href="/services/accounting-financial-reporting" className="link-item">
                Accurate Accounting
              </a>
            </li>
            <li>
              <a href="/services/tax-planning-compliance" className="link-item">
                Strategic Tax Solutions
              </a>
            </li>
            <li>
              <a href="/services/wealth-investment-management" className="link-item">
                Wealth Mastery
              </a>
            </li>
            <li>
              <a href="/services/loan-credit-card" className="link-item">
                Financing Solutions
              </a>
            </li>
            <li>
              <a href="/services/business-advisory-consulting" className="link-item">
                Business Growth Consulting
              </a>
            </li>
            <li>
              <a href="/services/data-analytics-reporting" className="link-item">
                Advanced Data Solutions
              </a>
            </li>
          </ul>
        </div>

        {/* Tools */}
        {/* <div>
          <h4 className="links-section-heading">TOOLS</h4>
          <ul className="links-list">
            <li>
              <a href="/mf-returns-calculator" className="link-item">
                MF Returns Calculator
              </a>
            </li>
            <li>
              <a href="/mf-sip-calculator" className="link-item">
                MF SIP Calculator
              </a>
            </li>
            <li>
              <a href="/mf-historic-nav" className="link-item">
                MF Historic NAV
              </a>
            </li>
            <li>
              <a href="/mf-dividend-historic" className="link-item">
                MF Dividend Historic
              </a>
            </li>
            <li>
              <a href="/mf-scheme-snapshot" className="link-item">
                MF Scheme Snapshot
              </a>
            </li>
            <li>
              <a href="/financial-tools" className="link-item">
                Financial Tools
              </a>
            </li>
          </ul>
        </div> */}

        {/* Contact Info */}
        <div>
          <h4 className="links-section-heading">CONTACT US</h4>
          <p className="contact-text">
            <strong>Tax O Wealth Advisors</strong>
            <br />
            Registered Office: <br />
            242, Patrakar Colony Mansarovar <br />
            Jaipur Rajasthan-302020. <br />
            Ph: 0141-4507527 <br />
            Mob: 98293-26555, 94686-23539 <br />
            Email: info@taxowealth.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default LinksSection;
